import { ActionTypes } from '../actions/types';

const initialState: any = {
  config: {
    show: false,
    children: undefined,
    height: '300px',
    width: '300px',
    title: undefined,
    description: undefined,
  },
};

export default function (
  state = initialState,
  action: { type: ActionTypes; payload: any }
) {
  const { type, payload } = action;

  switch (type) {
    case ActionTypes.SET_MODAL_CONFIG: {
      const [value, fieldName] = [payload.value, payload.fieldName];
      const config = { ...state.config };
      config[fieldName] = value;
      return {
        ...state,
        config: config,
      };
    }
    case ActionTypes.RESET_MODAL_CONFIG: {
      return {
        ...state,
        config: initialState.config,
      };
    }

    default:
      return state;
  }
}
